import type { ServiceType } from '@/pages/home/hooks/useWhatsApp';

interface FloatingWhatsAppProps {
  onOpenWhatsApp: (service?: ServiceType) => void;
}

export default function FloatingWhatsApp({ onOpenWhatsApp }: FloatingWhatsAppProps) {
  return (
    <>
      {/* Desktop floating button */}
      <div className="hidden md:block fixed bottom-6 right-6 z-40 group">
        <button
          onClick={() => onOpenWhatsApp()}
          className="w-14 h-14 flex items-center justify-center rounded-full bg-primary-500 text-foreground-950 shadow-lg hover:bg-primary-600 transition-all duration-300 hover:scale-110"
          aria-label="WhatsApp'tan Teklif Al"
        >
          <i className="ri-whatsapp-line text-2xl"></i>
        </button>
        <div className="absolute bottom-full right-0 mb-3 w-64 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 bg-background-50 text-foreground-700 text-sm font-label rounded-xl px-4 py-3 shadow-lg border border-background-200">
          Kaç kişilik yemek hizmetine ihtiyacınız var? Hemen sorun.
          <div className="absolute bottom-[-6px] right-5 w-3 h-3 bg-background-50 border-b border-r border-background-200 transform rotate-45"></div>
        </div>
      </div>

      {/* Mobile sticky bottom bar */}
      <div className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-accent-950 border-t border-accent-900/50 px-4 py-3">
        <button
          onClick={() => onOpenWhatsApp()}
          className="btn-primary w-full text-sm py-3"
        >
          <i className="ri-whatsapp-line text-lg"></i>
          WhatsApp&apos;tan Teklif Al
        </button>
      </div>
    </>
  );
}